module.exports = __webpack_public_path__ + "static/img/img5.9d39150.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/public/img5.png
// module id = 2+Bh
// module chunks = 3